export default function SARForm() {
  return (
    <div className="transaction-index-wrap-box-smartsend">
      <div className="mx-auto h-fit">
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSdqr61d0iGMD8c_8yJgcsqgzGPD88pF3jXQjTP_SJRAip82kA/viewform?embedded=true"
          width="740"
          height="4532"
        >
          Loading…
        </iframe>
      </div>
    </div>
  );
}
